import { closeTopUpDialog } from '../top-up-dialog/redux/actions';
import { isMobileApp } from 'utils';
export const update_billing_state = (billing_state) => ({ type: 'UPDATE_BILLING_STATE', billing_state });
export const yakassa_success_pay = (data) => async (dispatch, getState) => {
    dispatch({ type: 'BILLING_STATE__OK', data: data.billing_state });
    dispatch({ type: 'PAY__OK', data: { yakassa_success_pay: true } });
    const billing_settings = getState().billing.settings.data;
    dispatch({
        type: 'BILLING_SETTINGS__OK',
        data: { ...billing_settings, auto_payment: data?.auto_payment },
    });
};
export const yakassa_failure_pay = () => ({ type: 'YAKASSA_FAILURE_PAY' });
export const reset_yakassa_success_pay = () => (dispatch) => {
    dispatch({ type: 'PAY__OK', data: { yakassa_success_pay: null } });
};
export const select_billing_type = (state) => state.billing != null ? state.billing.type : undefined;
export const pay = (pay_intent) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'PAY__REQUEST' });
    try {
        const { billing_state } = await api.pay(pay_intent);
        dispatch({ type: 'BILLING_STATE__OK', data: billing_state });
        dispatch({ type: 'PAY__OK', data: { yakassa_success_pay: true } });
    }
    catch (error) {
        dispatch({
            type: 'PAY__FAIL',
            error,
        });
    }
};
export const disable_auto_payment = () => async (dispatch, getState, { api }) => {
    try {
        const response = await api.disable_auto_payment();
        if (response.billing_settings != null)
            dispatch({
                type: 'BILLING_SETTINGS__OK',
                data: response.billing_settings,
            });
    }
    catch (error) {
        dispatch({
            type: 'BILLING_SETTINGS__FAIL',
            error,
        });
    }
};
export const enableAutoPayment = () => async (dispatch, getState, { api }) => {
    let popup = null;
    if (!isMobileApp()) {
        popup = window.open('', '', 'popup, modal=yes, toolbar=no, location=no');
        if (!popup) {
            alert('не удалось открыть всплывающее окно');
            console.error("can't open popup for yakassa");
            return;
        }
    }
    const response = await api.enable_auto_payment();
    if (response.payment_url) {
        if (isMobileApp()) {
            window.open(response.payment_url, '_system');
        }
        else {
            if (popup) {
                popup.location = response.payment_url;
                popup.focus();
                setTimeout(() => popup?.focus(), 100);
            }
        }
    }
    else {
        popup?.close();
    }
    dispatch(closeTopUpDialog);
};
